import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'text-analysis',
  version: '1.0.0',
  properties: [
    {
      key: 'operation',
      label: 'Operation',
      type: 'options',
      required: true,
      default: 'sentiment',
      options: [
        { value: 'sentiment', name: 'Sentiment Analysis' },
        { value: 'keywords', name: 'Extract Keywords' },
        { value: 'summary', name: 'Summarize' },
        { value: 'entities', name: 'Extract Entities' },
      ],
    },
    {
      key: 'text',
      label: 'Text',
      type: 'string',
      required: true,
      typeOptions: {
        rows: 5,
      },
      placeholder: 'Enter text to analyze...',
    },
    {
      key: 'language',
      label: 'Language',
      type: 'options',
      default: 'en',
      options: [
        { value: 'en', name: 'English' },
        { value: 'es', name: 'Spanish' },
        { value: 'fr', name: 'French' },
        { value: 'de', name: 'German' },
      ],
    },
  ],
};

export default schema;
